import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TaxIntegrationClientService } from 'projects/qcloud-rest-client/src/lib/tax-integration-client.service';

@Component({
  selector: 'app-choose-integration-calendar',
  templateUrl: './choose-calendar.component.html',
  styleUrls: ['./choose-calendar.component.css']
})
export class ChooseIntegrationCalendarComponent implements OnInit {

  constructor(private taxClient: TaxIntegrationClientService, private translate: TranslateService,
    private toastr: ToastrService) { }

  isTax: boolean | null = null;
  originVal: boolean = false;
  beforeTimePrint: number;
  afterTimePrint: number;
  ngOnInit(): void {

    this.taxClient.getConfig(data => {
      this.isTax = data.isActive;
      this.originVal = data.isActive;
      this.beforeTimePrint = data.beforeTimePrint;
      this.afterTimePrint = data.afterTimePrint;
    }, () => { });
  }

  save() {
    this.taxClient.addOrUpdateConfig({ isActive: this.isTax, beforeTimePrint: this.beforeTimePrint, afterTimePrint: this.afterTimePrint }, () => {
      this.originVal = this.isTax;
      this.translate.get('tax-config-success').subscribe((msg: string) => {
        this.toastr.success("", msg);
      });
    }, () => { })
  }

}
